import {
  usePlaybackCurrentTs,
  usePlaybackIsPlaying,
  usePlaybackPause,
} from '@app/core/playback/hooks/usePlayback';
import { AuditMatch, Timestamp, toTimestamp } from '@mi-front/core';
import { useCallback } from 'react';
import { usePlayAuditMatch } from './usePlayAuditMatch';

/**
 * Play/pause control for an audit match: pause while playing inside the match range,
 * otherwise start playback from the match start.
 */
export function useAuditMatchPlaybackControl(match: AuditMatch) {
  const playMatch = usePlayAuditMatch(match);
  const pause = usePlaybackPause();
  const currentTs = usePlaybackCurrentTs();
  const isPlaying = usePlaybackIsPlaying();

  const startTs = toTimestamp(match.datetime);
  const endTs = (startTs + match.audio!.duration) as Timestamp;
  // Match window is start inclusive, end exclusive (same bounds as usePlayAuditMatch stopTs).
  const isInMatchRange = currentTs != null && currentTs >= startTs && currentTs < endTs;
  const showPause = isInMatchRange && isPlaying;

  const handleClick = useCallback(() => {
    if (showPause) {
      pause();
      return;
    }

    void playMatch();
  }, [showPause, pause, playMatch]);

  return { showPause, handleClick };
}
